import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import _ from "lodash";

import UrlFiltersContent, { UrlFiltersPageTitle } from "./UrlFiltersContent";
import { PROFILE_TAB_ACTIVE_CLASS } from "../../../profiles/components/profileTab/ProfileTab";
import { ProfileLink } from "../../../profiles/components/profileLink/ProfileLink";
import { getVisibleProfiles } from "../../../../store/profiles/profiles.selectors";
import { SettingsSidebarNavigation } from "../../../../components/settingsSidebarNavigation/SettingsSidebarNavigation";
import { GLOBAL_URL_FILTER_ID } from "../../urlFilters.constants";
import { AriaPageTitle } from "../../../../components/ariaPageTitle";
import { useSelectedProfileName } from "../../../settings/useSelectedProfileName";
import { withSettingsGuard } from "../../../../router/guards/withSettingsGuard";

const globalTab = {
  id: GLOBAL_URL_FILTER_ID,
  name: "global",
  type: "global",
  header: (
    <ProfileLink
      title="global"
      type="global"
      description="global_description"
      to={`/settings/url-filters/${GLOBAL_URL_FILTER_ID}`}
    />
  ),
  content: (
    <Fragment>
      <UrlFiltersContent profileId={GLOBAL_URL_FILTER_ID} />
    </Fragment>
  ),
};

const getTab = (profile) => ({
  id: profile.id,
  name: profile.name,
  type: profile.type,
  header: (
    <ProfileLink
      title={profile.type !== "custom" ? profile.type : profile.name}
      type={profile.type}
      description={`${profile.type}_description`}
      to={`/settings/url-filters/${profile.id}`}
    />
  ),
  content: <UrlFiltersContent profileId={profile.id} />,
});

export const UrlFiltersSettingPage = withSettingsGuard(() => {
  const profiles = useSelector(getVisibleProfiles, _.isEqual);
  const selectedProfileName = useSelectedProfileName(
    _.capitalize(globalTab.name)
  );

  return (
    <div className="url-filters">
      <AriaPageTitle
        pageKey="page_title_settings_block_and_allow_lists"
        pageValues={{
          profileName: selectedProfileName,
        }}
      />
      <SettingsSidebarNavigation
        tabs={[globalTab, ...profiles.map(getTab)]}
        activeTabClass={PROFILE_TAB_ACTIVE_CLASS}
        isUrlFiltersPage
        sidebarMenuHeader={
          <div className={"sidebar__header"}>
            <UrlFiltersPageTitle className={"sidebar__header--main"} />
            <h2>
              <FormattedMessage id={"profiles"} />
            </h2>
          </div>
        }
      />
    </div>
  );
});
